export const FETCH_ATTACHMENTS_REQUEST =
  'integrations/attachments/FETCH_ATTACHMENTS_REQUEST'
export const FETCH_ATTACHMENTS_REQUEST_STARTED =
  'integrations/attachments/FETCH_ATTACHMENTS_REQUEST_STARTED'
export const FETCH_ATTACHMENTS_REQUEST_SUCCESS =
  'integrations/attachments/FETCH_ATTACHMENTS_REQUEST_SUCCESS'
export const FETCH_ATTACHMENTS_REQUEST_FAILED =
  'integrations/attachments/FETCH_ATTACHMENTS_REQUEST_FAILED'
